import React, {useEffect, useRef, useState} from 'react';
import Loader from '../../application/ui-elements/Loader';
import PhaseLoader from '../../dashboard/ui-elements/PhaseLoader';

// const renderRichText = textArray => {
//     if (!textArray || !Array.isArray(textArray)) return '';
//     return textArray
//         .map(block => (block.type === 'paragraph' && block.children
//             ? block.children
//                 .map(child => (child.type === 'text'
//                     ? child.bold ? `<strong>${child.text}</strong>` : child.text
//                     : ''))
//                 .join('')
//             : ''))
//         .join('');
// };

const ImportResultsTable = ({importedData, loading, errors, publishData, errorMsg, isPublish}) => {
    const [currentPageSuccess, setCurrentPageSuccess] = useState(1);
    const [currentPageErrors, setCurrentPageErrors] = useState(1);
    const importRef = useRef(null);

    const itemsPerPage = 20;

    useEffect(() => {
        if (importRef.current) {
            importRef.current.scrollIntoView({behavior: 'smooth'});
        }
    }, [importedData, publishData]);

    if (loading) return (
        <div className="column">
            <PhaseLoader full={true} />
            <PhaseLoader full={true} />
        </div>
    );
    if (errors?.length && !importedData) return <div className="notification is-danger"><strong>Error:</strong> {errors}</div>;

    const fulfilledResults = importedData || [];
    const rejectedResults = errors || [];
    const paginate = (data, currentPage) => {
        const totalItems = data.length;
        const totalPages = Math.ceil(totalItems / itemsPerPage);
        const startIndex = (currentPage - 1) * itemsPerPage;
        return {
            totalItems,
            totalPages,
            startIndex,
            paginatedData: data.slice(startIndex, startIndex + itemsPerPage),
            pageNumbers: totalPages <= 3
                ? Array.from({length: totalPages}, (_, i) => i + 1)
                : currentPage === 1
                    ? [1, 2, 3]
                    : currentPage === totalPages
                        ? [totalPages - 2, totalPages - 1, totalPages]
                        : [currentPage - 1, currentPage, currentPage + 1],
        };
    };

    const {totalItems: totalItemsSuccess, totalPages: totalPagesSuccess, startIndex: startIndexSuccess, paginatedData: paginatedSuccessResults, pageNumbers: pageNumbersSuccess} = paginate(fulfilledResults, currentPageSuccess);
    const {totalItems: totalItemsErrors, totalPages: totalPagesErrors, startIndex: startIndexErrors, paginatedData: paginatedErrorResults, pageNumbers: pageNumbersErrors} = paginate(rejectedResults, currentPageErrors);

    const createPaginationHandlers = (setCurrentPage, totalPages) => ({
        goToFirst: () => setCurrentPage(1),
        goToPrevious: () => setCurrentPage(prev => Math.max(1, prev - 1)),
        goToNext: () => setCurrentPage(prev => Math.min(totalPages, prev + 1)),
        goToLast: () => setCurrentPage(totalPages),
        goToPage: page => setCurrentPage(page),
    });

    const successHandlers = createPaginationHandlers(setCurrentPageSuccess, totalPagesSuccess);
    const errorHandlers = createPaginationHandlers(setCurrentPageErrors, totalPagesErrors);

    const Pagination = ({currentPage, totalPages, pageNumbers, handlers, type}) => (
        <nav className="pagination is-centered" role="navigation" aria-label={`pagination for ${type}`}>
            <button className="button pagination-previous" onClick={handlers.goToFirst} disabled={currentPage === 1} aria-label={`Go to first page of ${type}`}>First</button>
            <button className="button pagination-previous" onClick={handlers.goToPrevious} disabled={currentPage === 1} aria-label={`Go to previous page of ${type}`}>Previous</button>
            <ul className="pagination-list">
                {pageNumbers.map(page => (
                    <li key={page}>
                        <button
                            className={`pagination-link ${page === currentPage ? 'is-current' : ''}`}
                            onClick={() => handlers.goToPage(page)}
                            aria-label={`Go to page ${page} of ${type}`}
                            aria-current={page === currentPage ? 'page' : undefined}
                        >
                            {page}
                        </button>
                    </li>
                ))}
            </ul>
            <button className="button pagination-next" onClick={handlers.goToNext} disabled={currentPage === totalPages} aria-label={`Go to next page of ${type}`}>Next</button>
            <button className="button pagination-next" onClick={handlers.goToLast} disabled={currentPage === totalPages} aria-label={`Go to last page of ${type}`}>Last</button>
            <div className="pagination-info mx-4">Page {currentPage} of {totalPages} ({type == 'error' ? totalItemsErrors : totalItemsSuccess} items)</div>
        </nav>
    );

    return (
        <div className="container mt-6">
            <h1 className="title" ref={importRef}>Import Results</h1>
            <div className="is-flex is-justify-content-space-between">
                <h2 className="subtitle">{isPublish ? 'Published imports' : 'Successful Imports:'}</h2>
                {!isPublish && (
                <button className="button" onClick={publishData}>
                    Publish imported
                </button>
                )}
            </div>
            {fulfilledResults.length === 0 ? (
                <p className="has-text-grey">No successful imports.</p>
            ) : (
                <>
                    <div className="table-container">
                        <table className="table is-striped is-hoverable is-fullwidth">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Element itemKey</th>
                                    <th>Title</th>
                                    {/* <th>Text</th> */}
                                    {/* <th>Item Key</th> */}
                                    {/* <th>Level</th> */}
                                    {/* <th>Locale</th> */}
                                    {/* <th>Gender</th> */}
                                    {/* <th>Phase Level</th> */}
                                    {/* <th>Valid From</th> */}
                                    {/* <th>Created At</th> */}
                                    {/* <th>Updated At</th> */}
                                    {/* <th>Published At</th> */}
                                    {/* <th>Entry API</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedSuccessResults.map((result, index) => (
                                    <tr key={index}>
                                        <td>{startIndexSuccess + index + 1}</td>
                                        <td>{result.value.itemKey}</td>
                                        <td>{result.value.title}</td>
                                        {/* <td dangerouslySetInnerHTML={{__html: renderRichText(result.value.text)}} /> */}
                                        {/* <td>{result.value.level}</td> */}
                                        {/* <td>{result.value.locale}</td> */}
                                        {/* <td>{result.value.gender}</td> */}
                                        {/* <td>{result.value.isPhaseLevel || 'N/A'}</td> */}
                                        {/* <td>{result.value.validFrom || 'N/A'}</td> */}
                                        {/* <td>{new Date(result.value.createdAt).toLocaleString()}</td> */}
                                        {/* <td>{new Date(result.value.updatedAt).toLocaleString()}</td> */}
                                        {/* <td>{result.value.publishedAt ? new Date(result.value.publishedAt).toLocaleString() : 'N/A'}</td> */}
                                        {/* <td>{result.entryApi}</td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        currentPage={currentPageSuccess}
                        totalPages={totalPagesSuccess}
                        pageNumbers={pageNumbersSuccess}
                        handlers={successHandlers}
                        type="successful imports"
                    />
                </>
            )}

            {rejectedResults.length > 0 && (
                <div className="mt-5 pb-6">
                    <h2 className="subtitle mt-6 has-text-weight-semibold is-size-3">Errors of import:</h2>
                    <div className="subtitle">{errorMsg.title}. {errorMsg.message}</div>
                    <div className="table-container">
                        <table className="table is-striped is-hoverable is-fullwidth">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Status</th>
                                    <th>Error Message</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedErrorResults.map((error, index) => (
                                    <tr key={index}>
                                        <td>{startIndexErrors + index + 1}</td>
                                        <td>{error.status}</td>
                                        <td>{error.reason.message || error?.reason}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        currentPage={currentPageErrors}
                        totalPages={totalPagesErrors}
                        pageNumbers={pageNumbersErrors}
                        handlers={errorHandlers}
                        type="error"
                    />
                </div>
            )}
        </div>
    );
};

export default ImportResultsTable;
